// extracted by mini-css-extract-plugin
module.exports = {"field-title":"_0fce717cdb--field-title--RAi6c","center":"_0fce717cdb--center--uD693","top":"_0fce717cdb--top--x4BJ6"};